import { BACKEND_API_BASE_URL } from "./utility";
import { getAttributionIds } from "./attribution";

/**
 * Build full-page OAuth start URL for Google / Microsoft signup or login.
 */
export function buildSocialAuthUrl(provider, intent, extra = {}) {
  const params = new URLSearchParams();
  params.set("intent", intent === "signup" ? "signup" : "login");

  if (extra.timezone_id) {
    params.set("timezone_id", String(extra.timezone_id));
  }
  if (extra.referral) {
    params.set("referral", String(extra.referral));
  }

  const attributionIds = getAttributionIds();
  if (attributionIds.anonymous_id) {
    params.set("anonymous_id", attributionIds.anonymous_id);
  }
  if (attributionIds.session_id) {
    params.set("session_id", attributionIds.session_id);
  }

  return `${BACKEND_API_BASE_URL}auth/${provider}/redirect?${params.toString()}`;
}

export function calendarSoftFailMessage(reason) {
  switch (reason) {
    case "already_connected":
      return "Your account was created, but this calendar is already connected to this MeetOcto account. You can manage calendars under Integrations.";
    case "max_accounts":
      return "Your account was created, but this MeetOcto account already has that calendar provider connected. Only one Google and one Outlook Calendar are allowed per account.";
    case "plan_limit":
    case "feature_locked":
      return "Your account was created, but calendar could not be connected due to your plan limits. You can manage calendars under Integrations.";
    case "missing_refresh_token":
    case "api_error":
    default:
      return "Your account was created, but calendar could not be connected automatically. You can connect it later under Integrations.";
  }
}
